import AppHeader from "./components/AppHeader/AppHeader.js";
import AppFooter from "./components/AppFooter/AppFooter.js";
import Home from "./pages/Home/Home.js";

class App {
  constructor() {
    this.header = new AppHeader();
    this.footer = new AppFooter();
    this.homePage = new Home();
  }

  mount(selector) {
    const container = document.querySelector(selector);
    if (!container) {
      throw new Error(`Container not found: ${selector}`);
    }

    // Structure principale de l'app
    container.innerHTML = `
      <div class="app-layout">
        <div id="header-mount"></div>
        <main id="main-content" class="main-content">
          <div id="home-mount"></div>
        </main>
        <div id="footer-mount"></div>
      </div>
    `;

    // Montage des composants
    this.header.mount("#header-mount");
    this.footer.mount("#footer-mount");
    this.homePage.mount("#home-mount");
  }
}

export default App;
